import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import JsonBlockGenerator from '../components/JsonBlockGenerator';

export default class DrPrimaryDialog extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <JsonBlockGenerator filename={'dr_primary_dialog.json'} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
